(ns hypnos.dme.db
  "DME database/state"
  (:require [hypnos.config :as config]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; State

(def default-db
  {:app-name                  "TherapistAssist"
   ;; UI stuff
   :ui                        {:active-panel {:name   :dashboard-panel
                                              :params nil}
                               :aside        {:expanded? false}
                               :loading?     false}
   ;; errors
   :error                     {:type    nil
                               :message nil}
   ;; auth stuff
   :auth                      {;; Hypnos user
                               :user   nil
                               ;; Cognito groups of the current (user) session
                               :groups #{}}
   ;; current catalog
   :catalog                   []
   ;; map of organizations (by :organization/id for the user
   :organizations             {}
   ;; current (selected) organization (with the associated users)
   :organization              nil
   ;; communication
   :communication             {:status  nil
                               :message nil}
   ;; current patient w/ associated consult(s)
   :patient                   nil
   ;; the patient portrait
   :portrait                  {:upload-status nil
                               :file          nil
                               :issues        []}
   ;; recommendations & note (used for exchanges)
   :recommendations-with-note {:recommendations      nil
                               :recommendations-note nil}
   ;; list of consults
   :consults                  {:consults nil
                               :offset   0
                               :limit    config/PAGE-SIZE}
   ;; list of patients
   :patients                  {:patients nil
                               :filter   {:scope            "user"
                                          :consult-states   #{:consult-state/pending}
                                          :organization-ids #{}}
                               :query    nil
                               :offset   0
                               :limit    config/PAGE-SIZE
                               :total    0}
   ;; current referral (patient w/ consult)
   :referral                  nil
   ;; active GraphQL subscriptions
   :subscriptions             {}})
